var _excluded = ["useDialog"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ModalWithDialog from './withDialog.js';
import ModalNoDialog from './noDialog.js';

// Check if browser supports dialog element
var supportsDialog = function supportsDialog() {
  if (typeof window === 'undefined') return true; // Default to supporting dialog during SSR
  return typeof HTMLDialogElement === 'function';
};
var Modal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$useDialog = _ref.useDialog,
    useDialog = _ref$useDialog === void 0 ? supportsDialog() : _ref$useDialog,
    props = _objectWithoutProperties(_ref, _excluded);
  if (useDialog) {
    return /*#__PURE__*/React.createElement(ModalWithDialog, _extends({}, props, {
      ref: ref
    }));
  }
  return /*#__PURE__*/React.createElement(ModalNoDialog, _extends({}, props, {
    ref: ref
  }));
});
Modal.displayName = 'Modal';
Modal.propTypes = {
  /** A list of actions rendered in the action bar. */
  actions: PropTypes.array,
  /** The content of the modal. */
  children: PropTypes.element,
  /** A listener that is called once clicked outside of the modal. */
  onClose: PropTypes.func,
  /** A secondary Action in the header of the modal. */
  secondaryAction: PropTypes.func,
  /** Sets the title of the modal. */
  title: PropTypes.string,
  /** A ref to the element that triggered the modal. Focus will be restored to this element when the modal closes. */
  triggeredByRef: PropTypes.object,
  /** Force using dialog element (true) or overlay fallback (false). Defaults to browser support detection. */
  useDialog: PropTypes.bool,
  /** Sets the visiblity of the modal. */
  visible: PropTypes.bool,
  /** Sets the zIndex of the modal. */
  zIndex: PropTypes.number
};
export default Modal;